import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.COLLECTION_TYPES),
    addCollectionType: payload => axios.post(HTTP.COLLECTION_TYPE, payload),
    updateCollectionType: payload => axios.put(HTTP.COLLECTION_TYPE, payload),
    deleteCollectionType: payload => axios.delete(HTTP.COLLECTION_TYPE, { params: { id: payload } })
}
